export function createDomReadyReplay() {
  const originalAdd = document.addEventListener.bind(document);
  const callbacks: EventListenerOrEventListenerObject[] = [];
  let flushed = false;
  function invoke(cb: EventListenerOrEventListenerObject) {
    const event = new Event('DOMContentLoaded');
    if (typeof cb === 'function') cb.call(document, event);
    else cb.handleEvent(event);
  }
  function flush() {
    if (flushed) return;
    flushed = true;
    callbacks.splice(0).forEach((cb) => {
      try { invoke(cb); } catch (error) { console.error('[BeatLine Vite C6] DOMContentLoaded callback error', error); }
    });
  }
  document.addEventListener = function patchedAddEventListener(type: string, listener: EventListenerOrEventListenerObject | null, options?: boolean | AddEventListenerOptions) {
    if (type === 'DOMContentLoaded' && listener) {
      if (flushed) queueMicrotask(() => invoke(listener));
      else {
        callbacks.push(listener);
        if (document.readyState !== 'loading') queueMicrotask(flush);
      }
      return;
    }
    if (!listener) return;
    return originalAdd(type, listener, options);
  } as typeof document.addEventListener;
  originalAdd('DOMContentLoaded', flush, { once: true });
  return { flushIfNeeded: () => { if (document.readyState !== 'loading') flush(); }, restore: () => { document.addEventListener = originalAdd; } };
}
